import { Directive, Input, OnChanges, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * 
 *  <div *isAdmin>
 *   adminロールか否かによって表示非表示を切り替える。adminロールの場合に表示される。
 *  </div>
 * 
 */
@Directive({
  selector: '[isAdmin]'
})
export class IsAdmin implements OnInit
{
  public constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService)
  {
  }


  ngOnInit(): void {
    if (this.authService.isAdmin()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
